import React, { FC } from "react";
import type { ContentfulNextPageType } from "@/types";
import { Link } from "./link";

export const NextPage: FC<ContentfulNextPageType> = ({
  title,
  subtitle,
  entry,
}) => {
  return (
    <section className="nextPage">
      <div className="wrapper">
        <Link
          href={entry}
          noStyle
          className="nextPage--entry"
          onMouseEnter={(event) => {
            const target = event.currentTarget as HTMLElement;
            target
              .querySelector("svg")
              ?.classList.add("hover-animation-bounce-horizontal");
          }}
        >
          <div className="nextPage--subtitle">{subtitle}</div>
          <div className="nextPage--title" data-title={title}>
            <span>{title}</span>
            <svg
              width="156"
              height="20"
              viewBox="0 0 156 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onAnimationEnd={(event) => {
                const target = event.target as HTMLElement;
                target.classList.remove("hover-animation-bounce-horizontal");
              }}
            >
              <path d="M146 0L156 10L146 20" fill="currentColor" />
              <path
                d="M0 10L146 10"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinejoin="round"
                className="line"
              />
            </svg>
          </div>
        </Link>
      </div>
    </section>
  );
};
